module.exports = __webpack_public_path__ + "img/ref-naturel-3.d3e1a61.png";